export interface CupisCoverageData {
  lanes?: Record<string, { at: number; rowsReceived: number; pageFull: boolean; sports: Record<string, number>; markets: Record<string, number> }>;
  refusals?: Record<string, number>;
  localPairs?: number;
}
const names: Record<string, string> = { soccer: 'Футбол', hockey: 'Хоккей', basketball: 'Баскетбол', tennis: 'Теннис', cs2: 'CS2', dota2: 'Dota 2', lol: 'League of Legends', valorant: 'Valorant', volleyball: 'Волейбол', american_football: 'Американский футбол', other: 'Другие', mma: 'ММА', baseball: 'Бейсбол', handball: 'Гандбол', boxing: 'Бокс', badminton: 'Бадминтон' };
export function CupisCoverage({ data }: { data?: CupisCoverageData }): React.ReactElement {
  return <div className="cupis-coverage">
    {Object.entries(data?.lanes ?? {}).map(([lane, sample]) => <div key={lane}>
      <span className="cupis-label">{lane === 'live' ? 'Лайв' : 'Прематч'} · {sample.rowsReceived} получено</span>
      <div className="cupis-sports">{Object.entries(sample.sports).map(([s, n]) => <span key={s}>{names[s] ?? 'Другой спорт'} <b>{n}</b></span>)}</div>
    </div>)}
    <small>Состав последнего ответа, не вся линия БК. Дополнительных переливов: {data?.localPairs ?? 0}.</small>
  </div>;
}
